/**
 * Rectangle interface.
 *
 * @public
 * {@docCategory IRectangle}
 */
export interface IRectangle {
  left: number;
  top: number;
  width: number;
  height: number;
  right?: number;
  bottom?: number;
}
